import useLazyData from '@/hooks/useLazyData';
import dynamic from 'next/dynamic';
import Skeleton from './skeleton';
import ContentFeedSkeletonV2 from './skeleton-v2';

const DynamicProductList = dynamic(() => import('./feed-list'), {
  ssr: false,
  loading: Skeleton
});

const DynamicProductListV2 = dynamic(() => import('./feed-list-v2'), {
  ssr: false,
  loading: (props: any) => <ContentFeedSkeletonV2 {...props} />
});

const ContentFeed = props => {
  const { ref: viewRef, show } = useLazyData({
    threshold: 0.01,
    rootMargin: '10px 0px 0px 0px'
  });

  const isV2 = props.properties?.version === 'v2';

  const skeleton = isV2 ? <ContentFeedSkeletonV2 /> : <Skeleton />;

  if (!show) {
    return <div ref={viewRef}>{skeleton}</div>;
  }

  if (isV2) {
    return <DynamicProductListV2 skeleton={skeleton} {...props} />;
  }

  return <DynamicProductList skeleton={skeleton} {...props} />;
};

export default ContentFeed;
